import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';

import Disclaimer from '../../../components/Disclaimer';
import MyPlans from './MyPlans';
import Constants from '../../../services/Constants';
import {
  changeDocumentsViewFilter,
  dispatchLetterFilter,
} from '../../../actions';

export const AllPlans = (props) => {
  const [plans, setPlans] = useState(props.plansByLetter);
  const [filter, setFilter] = useState();

  useEffect(() => {
    setPlans(props.plansByLetter);
  }, [props.plansByLetter]);

  async function plansRequest(letter) {
    await props.requestPlansForLetter(letter);
  }

  const filterPlans = (newFilter) => {
    if (newFilter !== filter) {
      plansRequest(newFilter);
      props.dispatchLetterFilter(newFilter);
    }
    setFilter(newFilter);
    props.changeDocumentsViewFilter(Constants.ALL_PLANS, {
      ...filter,
      [Constants.ALL_PLANS]: {},
    });
  };

  const renderFilter = () => {
    const alphabet = '#abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');
    return (
      <div className="filterList">
        {_.map(alphabet, (filter) => (
          <Button
            key={filter}
            onClick={() => filterPlans(filter)}
            id={`${filter}-button`}>
            {filter}
          </Button>
        ))}
      </div>
    );
  };

  const noPlansMessage = () => {
    if (props.letterFilter && plans?.length === 0) {
      return <div className="no-plans-message">{`No plans available`}</div>;
    } else if (!props.letterFilter && !plans) {
      return (
        <div className="no-plans-message">{`Select a Letter to filter`}</div>
      );
    }
    return null;
  };

  return (
    <div>
      <Disclaimer id="allPlansDisclaimer" name="allPlansDisclaimer col-lg-5">
        <ul>
          <li>
            <b>Published</b> portfolios have an assigned ClientHUB Administrator
            in Backstop and are visible to clients with permission to access
            them.
          </li>
          <li>
            <b>Unpublished</b> portfolios do not have a ClientHUB Administrator
            in Backstop and will not show for any clients until the ClientHUB
            Administrator is defined in Backstop.
          </li>
          <li>
            You can <b>Hide Unpublished Portfolios</b> from this view using the
            toggle at the top of this page.
          </li>
          <li>
            See{' '}
            <a href="https://central.nepc.com/x/OhZwDw">
              ClientHUB Set-Up Checklist
            </a>{' '}
            for more details on configuring the client experience.
          </li>
        </ul>
      </Disclaimer>
      <Row>
        <Col lg={12} className="filter">
          {renderFilter()}
        </Col>
      </Row>
      <MyPlans
        plans={plans}
        isMyPlans={false}
        filterKey={Constants.ALL_PLANS}
        singleClient={false}
      />
      {noPlansMessage()}
    </div>
  );
};

AllPlans.propTypes = {
  changeDocumentsViewFilter: PropTypes.func,
  plansByLetter: PropTypes.array,
  requestPlansForLetter: PropTypes.func.isRequired,
  dispatchLetterFilter: PropTypes.func,
  portfoliosViewModel: PropTypes.bool,
  emptyLetter: PropTypes.bool,
  letterFilter: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    portfoliosViewModel: state.ui.portfoliosViewModel,
    letterFilter: state.ui.letterFilter,
  };
};

export default connect(mapStateToProps, {
  changeDocumentsViewFilter,
  dispatchLetterFilter,
})(AllPlans);
